export default __webpack_public_path__ + "static/auth-background-89e27f071f17f1dc7b97dc98e529d8e6.jpg";